// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__hwUvn","action":"Sidebar_action__uNhJR","img":"Sidebar_img__ILA86","img_bigger":"Sidebar_img_bigger__496Oe"};